import { createContext, useContext } from "react";
import { playersApi, tournamentsApi, matchResultsApi } from "../services/api";
import {
  guestPlayersApi,
  guestTournamentsApi,
  guestMatchResultsApi,
} from "../services/guestApi";

const ApiContext = createContext(null);

export function ApiProvider({ isGuest, children }) {
  const value = isGuest
    ? {
        playersApi: guestPlayersApi,
        tournamentsApi: guestTournamentsApi,
        matchResultsApi: guestMatchResultsApi,
      }
    : {
        playersApi,
        tournamentsApi,
        matchResultsApi,
      };

  return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
}

export function useApi() {
  return useContext(ApiContext);
}
